import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";
import HomeView from "../views/lanhu_wangzhanshouye/index.vue";
import edit from "../views/edit/Edit.vue";
import admin from "../views/admin/Admin.vue";
import cover from "../components/edit/cover.vue";
import content from "../components/content/content.vue";
import detail from "../components/detail/detail.vue";
import release from "../components/release/release.vue";
import integral from "../components/integral/index.vue";
import list from "../views/list/list.vue";
import level from "../views/level/level.vue";
import login from "../views/login/LoginForm.vue";
import setting from "../views/setting/setting.vue";
import Map from "../views/map/index.vue";
import CustomeMap from "../components/canvans/CustomeMap.vue";
import { ElMessage, ElMessageBox } from "element-plus";
import { getToken } from "@/utils/auth";
import audit from "@/views/admin/audit.vue";
import personnel from "@/views/admin/personnel.vue";
import apply from "@/views/admin/apply.vue";
import feedback from "@/views/admin/feedback.vue";
import store from "@/store";
import questionnaires from "@/components/questionnaires/index.vue";
import background from "@/components/background/index.vue";
import backgroundEnd from "@/components/backgroundEnd/index.vue";
import role from "@/components/role/index.vue";
import advertise from "@/views/admin/advertise.vue";
import ticket from "@/views/admin/ticket.vue";
import gameReview from "@/components/gameReview/index.vue";
const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    name: "home",
    component: HomeView,
    children: [
      {
        path: ":id",
        component: HomeView,
      },
    ],
  },
  {
    path: "/map",
    name: "map",
    component: CustomeMap,
  },
  {
    path: "/edit/:id",
    name: "edit",
    component: edit,
    meta: { needLogin: true },
    children: [
      {
        path: "cover",
        component: cover,
      },
      {
        path: "content",
        component: content,
      },
      {
        path: ":detailId",
        component: detail,
      },
      {
        path: "release",
        component: release,
      },
      {
        path: "integral",
        component: integral,
      },
      {
        path: "questionnaires",
        component: questionnaires,
      },
      {
        path: "background",
        component: background,
      },
      {
        path: "role",
        component: role,
      },
      {
        path: "backgroundEnd",
        component: backgroundEnd,
      },
      {
        path: "gameReview",
        component: gameReview,
      },
    ],
  },
  {
    path: "/admin/aabb",
    name: "admin",
    component: admin,
    meta: { isAdmin: true, needLogin: true },
    redirect: "/admin/aabb/audit",
    children: [
      {
        path: "audit",
        component: audit,
      },
      {
        path: "personnel",
        component: personnel,
      },
      {
        path: "apply",
        component: apply,
      },
      {
        path: "feedback",
        component: feedback,
      },
      {
        path: "advertise",
        component: advertise,
      },
      {
        path: "ticket",
        component: ticket,
      },
    ],
  },
  {
    path: "/about",
    name: "about",
    component: () =>
      import(
        /* webpackChunkName: "about" */ "@/views/lanhu_youxixiangqingye/index.vue"
      ),
  },
  {
    path: "/list",
    name: "list",
    component: list,
    meta: { needLogin: true },
  },
  {
    path: "/login",
    name: "Login",
    component: login,
  },
  {
    path: "/setting",
    name: "set",
    component: setting,
    meta: { needLogin: true },
  },
  {
    path: "/level/:partnerId/:id",
    name: "level",
    component: level,
    meta: { needLogin: true },
  },
];

const createNewRouter = () => {
  return createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes,
  });
};

let router = createNewRouter();

export const resetRouter = () => {
  router = createNewRouter();
};

router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.needLogin)) {
    const token = getToken();
    if (!token) {
      ElMessage.error("请先登录");
      next({ path: "/" });
    } else if (to.matched.some((record) => record.meta.isAdmin)) {
      if (store.state.user.status == 0) {
        ElMessage.error("无权限访问");
        next({ path: "/" });
      } else {
        next();
      }
    } else {
      next();
    }
  } else {
    next();
  }
});

export default router;
